module.exports = __webpack_public_path__ + "img/page-header.017a28e.png";